export default __webpack_public_path__ + "static/media/a-icon-map-location-on.909b90a3.svg";